import { Link } from 'react-router-dom';
import type { Video } from '@/types/video';
import { getCategoryMeta } from '@/types/video';
import { formatViews } from '@/lib/videoData';

export default function VideoListItem({ video, rank }: { video: Video; rank?: number }) {
  const meta = getCategoryMeta(video.category);

  return (
    <Link
      to={`/detail/${video.id}`}
      className="group flex items-center gap-3 rounded-lg border border-background-800/70 bg-background-900 p-2.5 transition-colors hover:border-primary-500/60 hover:bg-background-800/60"
    >
      <div className="poster-zoom relative h-24 w-[68px] flex-shrink-0 overflow-hidden rounded-md bg-background-800">
        <img
          src={video.cover}
          alt={`${video.title}封面`}
          title={`${video.title} - 桃子视频`}
          className="h-full w-full object-cover object-top"
        />
        {typeof rank === 'number' && (
          <span
            className={`absolute left-0 top-0 flex h-5 w-5 items-center justify-center rounded-br-md text-[11px] font-bold ${
              rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-950/80 text-foreground-200'
            }`}
          >
            {rank}
          </span>
        )}
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-semibold text-foreground-50 transition-colors group-hover:text-primary-400">
          {video.title}
        </h3>
        <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-400">
          {video.description}
        </p>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="text-primary-400">{meta?.name}</span>
          <span>{video.year}</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line" />
            {formatViews(video.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}